/* ==========================================================================
   Temi — copiati da flusso-urgenze.html (righe 1046-1071, 695-698).
   ACTOR_COLORS non vive più qui: il colore di ogni attore è nel documento
   (Participant.colors). Restano qui le superfici SVG (THEME) e i colori del
   markup testuale inline (COLORMAPS), che servono al rendering a runtime.
   ========================================================================== */

export type ThemeName = "dark" | "light";

/** Colori del testo inline <color:#…> per tema. */
export const COLORMAPS: Record<ThemeName, Record<string, string>> = {
  dark: { red: "#ef7368", green: "#a6cf4e", blue: "#6db2ec", orange: "#e6a659" },
  light: { red: "#b3261e", green: "#1a7a45", blue: "#1e5fa8", orange: "#b06a1a" },
};

export interface ThemePalette {
  headBg: string;
  headLine: string;
  cardFill: string;
  cardOn: string;
  cardOff: string;
  gutterBg: string;
  gutterLine: string;
  bandClosed: string;
  bandOpen: string;
  badge: string;
  chev: string;
  bandDash: string;
  lifeOn: string;
  lifeOff: string;
  segFill: string;
  frameFill: string;
  frameBase: number;
  frameStep: number;
  frameStroke: string;
  pillFill: string;
  pillStroke: string;
  divider: string;
  barBase: string;
  noteFill: string;
  noteStroke: string;
  noteBar: string;
}

/** Superfici SVG per tema (servono al draw-time, non stanno nel CSS). */
export const THEME: Record<ThemeName, ThemePalette> = {
  dark: {
    headBg: "#111111", headLine: "#2a2c2f", cardFill: "#191919", cardOn: "#33363b", cardOff: "#26282b",
    gutterBg: "#111111", gutterLine: "#242629",
    bandClosed: "#181818", bandOpen: "#1e1e1f", badge: "#bfd427", chev: "#8a9099", bandDash: "#3a3d42",
    lifeOn: "#3a3d42", lifeOff: "#242629", segFill: "#191919",
    frameFill: "#ffffff", frameBase: 0.022, frameStep: 0.026, frameStroke: "#34373c",
    pillFill: "#1c1c1d", pillStroke: "#34373c", divider: "#34373c",
    barBase: "#151515", noteFill: "#1f1c14", noteStroke: "#3c3626", noteBar: "#d9bc63",
  },
  light: {
    headBg: "#fbfbfa", headLine: "#e5e8ec", cardFill: "#ffffff", cardOn: "#dfe4e9", cardOff: "#e8ebee",
    gutterBg: "#fbfbfa", gutterLine: "#eef0f2",
    bandClosed: "#e7ecf1", bandOpen: "#eef2f6", badge: "#bfd427", chev: "#5c6b7a", bandDash: "#c2ccd5",
    lifeOn: "#d5dae0", lifeOff: "#eaedef", segFill: "#ffffff",
    frameFill: "#2f4a63", frameBase: 0.016, frameStep: 0.02, frameStroke: "#ccd4db",
    pillFill: "#fbfbfa", pillStroke: "#ccd4db", divider: "#c2ccd5",
    barBase: "#ffffff", noteFill: "#fdf8e8", noteStroke: "#e5d5a4", noteBar: "#d9bc63",
  },
};
